import CampaignScene from "../components/CampaignScene.js";
import DifferenceScene from "../components/DifferenceScene.js";
import FinalCall from "../components/FinalCall.js";
import HowSection from "../components/HowSection.js";
import WelcomeHero from "../components/WelcomeHero.js";

const WelcomePage = () => (
  <>
    <WelcomeHero />
    <CampaignScene />
    <HowSection />
    <DifferenceScene />
    <FinalCall />
  </>
);

export default WelcomePage;
